import { CommonModule } from '@angular/common';
import {
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output
} from '@angular/core';
import {
	TextBadgeComponent,
	TitleDescriptionComponent
} from '@array-app/frontend/common';
import { ResourceListItemComponent } from '@array-app/frontend/resource-list';
import { User } from '@array-app/shared/types';
import { TranslateModule } from '@ngx-translate/core';
import { FullNamePipe } from '../../pipes';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
	standalone: true,
	imports: [
		TranslateModule,
		ResourceListItemComponent,
		CommonModule,
		TitleDescriptionComponent,
		TextBadgeComponent,
		UserAvatarComponent,
		FullNamePipe
	],
	selector: 'app-resource-list-user-item',
	templateUrl: 'resource-list-user-item.component.html',
	styleUrls: ['resource-list-user-item.component.scss']
})
export class ResourceListUserItemComponent {
	@HostBinding('class.resource-item-alias')
	resourceItemAlias = true;

	@Input() user!: User;

	@Input() disabled = false;

	@Input() clickable = false;

	@Output()
	valueSelect = new EventEmitter<void>();

	onSelect() {
		this.valueSelect.emit();
	}
}
